import fetch from 'services/request';
import { CreateCustomerBody, GetCustomerListParams, GetTicketByCustomerIdParams, UpdateCustomerBody } from './constants';

const API_V1 = '/api/v1';
const CUSTOMER_BASE_URL = API_V1 + '/customer';
const BILL_BASE_URL = API_V1 + '/bill';
const customerApis = {
  customer: {
    getList: (params: GetCustomerListParams) =>
      fetch({
        method: 'get',
        url: `${CUSTOMER_BASE_URL}/list`,
        params,
      }),

    getDetail: (id: string) =>
      fetch({
        method: 'get',
        url: `${CUSTOMER_BASE_URL}/detail/${id}`,
      }),

    create: (data: CreateCustomerBody) =>
      fetch({
        method: 'post',
        url: `${CUSTOMER_BASE_URL}/create`,
        body: data,
      }),

    update: (data: UpdateCustomerBody) =>
      fetch({
        method: 'put',
        url: `${CUSTOMER_BASE_URL}/update/${data.id}`,
        body: data,
      }),

    delete: (id: string) =>
      fetch({
        method: 'delete',
        url: `${CUSTOMER_BASE_URL}/delete/${id}`,
      }),

    deleteMultiple: (ids: string[]) =>
      fetch({
        method: 'post',
        url: `${CUSTOMER_BASE_URL}/delete-multiple`,
        body: ids,
      }),
    getSummary: () =>
      fetch({
        method: 'get',
        url: `${CUSTOMER_BASE_URL}/summary`,
      }),
    updatePoint: (data: { customerId: string; point: number }) =>
      fetch({
        method: 'post',
        url: `${CUSTOMER_BASE_URL}/update-point`,
        body: data,
      }),
    getTicketsByCustomerId: (params: GetTicketByCustomerIdParams) =>
      fetch({
        method: 'get',
        url: `${BILL_BASE_URL}/list-ticket-customer/${params.customerId}`,
        params,
      }),
  },
};

export default customerApis;
